export default __webpack_public_path__ + "static/media/web3-bg.a8043935.jpg";